module.exports = __webpack_public_path__ + "static/img/animales_04.23020952.jpg";